import {DOM} from "../../../../../public/js/utils/DOM";

export namespace ControlsFormSalesInfoBoxInput {

    class Config {
        public static readonly inputContainerClass = "SalesInfoBoxInput";
    }

    export class Control {

        /**
         * Main initialization
         * @param container - form container
         */
        public static initialize(container?: HTMLElement) : void {
            const inputs = DOM.Parser.getHtmlElements(Config.inputContainerClass, container, true) as HTMLCollectionOf<HTMLDivElement>;
            for (let i = 0; i < inputs.length; i++) {
                this.initializeElement(inputs[i]);
            }
        }

        /**
         * Run input initialization
         * @param element - concrete input element
         * @private
         */
        private static initializeElement(element: HTMLDivElement) : void {

            // Update size of container
            const parent = DOM.Parser.getParentElement(element);
            parent.classList.remove('s12', 'm6', 'l4', 'customDesign-forms-field', 'input-field');
        }
    }
}